import { render, staticRenderFns } from "./campaign-inactivate.vue?vue&type=template&id=5b7c7b2a"
import script from "./campaign-inactivate.vue?vue&type=script&lang=js"
export * from "./campaign-inactivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports